export default __webpack_public_path__ + "static/media/stars_sound.7ff7247c.mp3";